<template>
  <div class="mt-2">
    <v-card>
      <v-toolbar
        dense
        color="white"
        class="elevation-0"
      >
        <v-toolbar-title>
          <v-icon>mdi-comment-outline</v-icon>
          הערות
        </v-toolbar-title>
        <v-spacer />
        <v-btn
          @click="add"
          text
          color="primary"
        >
          <v-icon class="me-2">mdi-plus</v-icon>
          הוספת הערה
        </v-btn>
      </v-toolbar>
      <v-divider />
      <v-card-text>
        <v-row>
          <v-col>
            <v-progress-linear
              indeterminate
              height="2"
              v-if="fetching"
            ></v-progress-linear>
            <template v-else-if="notes.length">
              <note
                v-for="(item, index) in notes"
                :key="`note${index}`"
                :note="item"
              />
            </template>
            <v-alert
              :value="true"
              color="white"
              class="ma-0 grey--text"
              dense
              v-else
            >
              אין הערות
            </v-alert>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import Note from "./Note";
import { format, isAfter } from "date-fns";

export default {
  data() {
    return {
      tab: null,
      fetching: true,
      removing: false
    };
  },
  computed: {
    notes() {
      return Object.values(this.$store.state.entities.notes)
        .filter(item => {
          return (
            item[this.parentType] && item[this.parentType] === this.parentId
          );
        })
        .sort((a, b) => {
          return isAfter(a.created, b.created) ? -1 : 1;
        });
    }
  },
  methods: {
    format,
    fetch() {
      this.fetching = true;
      let query = {};
      query[this.parentType] = this.parentId;
      this.$store
        .dispatch("API_GET", {
          url: "/notes",
          entityType: "notes",
          schema: "noteListSchema",
          params: { q: JSON.stringify(query) }
        })
        .catch(err => {
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: err.message,
            color: "error"
          });
        })
        .finally(() => {
          this.fetching = false;
        });
    }
  },
  props: ["parentId", "parentType", "add"],
  mounted() {
    this.fetch();
  },
  watch: {},
  components: {
    Note
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
